import { Grid, Typography, Box } from '@material-ui/core';
import { Layout } from '@roc/client-portal-shared/components';
import { Paper } from '@roc/ui';
import { LoanSubType } from '@roc/feature-utils';
import { useHistory, useParams } from 'react-router';
import { routeByLoanSubType } from '@roc/feature-loans';
import { Link } from 'react-router-dom';
import { selectLoanTypeModalBg } from '../assets';
import { observer } from 'mobx-react';
import { makeStyles } from '@material-ui/core/styles';
import { useBorrowerLoanSubmissionStore } from '../hooks/useBorrowerLoanSubmissionStore';
import { PublicLoanSubmissionStore } from '../stores';
import {
  fixFlipCover,
  groundUpCover,
  singlePropertyCover,
} from '../assets';

const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(4),
    borderRadius: theme.spacing(2),
    boxShadow:
      'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
  },
  title: {
    fontSize: '48px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '116.7%',
    padding: theme.spacing(2),
  },
  subTitle: {
    fontSize: '34px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '123.5%',
    letterSpacing: '0.25px',
  },
  body: {
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '175%',
    letterSpacing: '0.15px',
  },
  headerImg: {
    width: '100%',
    height: 120,
    objectFit: 'cover',
  },
}));

export const LandingPage = observer(({ currentRoutes }) => {
  const classes = useStyles();
  const { push } = useHistory();
  const { assignee } = useParams<{ assignee?: string }>();
  const { borrowerLoanSubmissionStore } = useBorrowerLoanSubmissionStore();
  const publicLoanSubmissionStore = borrowerLoanSubmissionStore as PublicLoanSubmissionStore;

  const buildProductUrl = (url: string) => (assignee ? `${url}/${assignee}` : url);

  return (
    <Layout maxWidth="lg">
      <Typography variant="h3" className={classes.title}>
        Select Product
      </Typography>
      <Paper className={classes.paper}>
        <Box mx={'auto'} mb={4} mt={4}>
          <Grid container direction="row" spacing={2} justifyContent="center" alignItems='center'>
            <Grid item>
              <ProductCard
                name={'Fix & Flip'}
                text={
                  <>
                    Short-term financing to purchase and/or renovate, then
                    sell or rent, non-owner occupied homes with 1-4 units.
                  </>
                }
                url={buildProductUrl(currentRoutes.children[
                  routeByLoanSubType[LoanSubType.FIX_AND_FLIP]
                ].url)}
                image={fixFlipCover}
              />
            </Grid>
            <Grid item>
              <ProductCard
                name={'Ground Up Construction'}
                text={
                  <>Short-term financing to build new homes with 1-4 units.</>
                }
                url={buildProductUrl(currentRoutes.children[
                  routeByLoanSubType[LoanSubType.GROUND_UP]
                ].url)}
                image={groundUpCover}
              />
            </Grid>
            <Grid item>
              <ProductCard
                name={'Single Property Rental'}
                text={
                  <>
                    Long-term financing to purchase or refinance a non-owner
                    occupied rental property with 1-4 units.
                  </>
                }
                url={buildProductUrl(currentRoutes.children[
                  routeByLoanSubType[LoanSubType.SINGLE_PROPERTY]
                ].url)}
                image={singlePropertyCover}
              />
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Layout>
  );
});

const ProductCard = observer(({ url, image, name, text }) => {
  const classes = useStyles();
  return (
    <Link to={url}>
      <Box
        style={{
          border: '1px solid #5E5E5E4D',
          borderRadius: '14px',
          width: '340px',
          height: '340px',
        }}
      >
        <Box
          height="70px"
          paddingLeft="20px"
          paddingRight="20px"
          display="flex"
          alignItems="center"
        >
          <Typography variant="h6" style={{ fontSize: '24px', color: 'black' }}>
            {name}
          </Typography>
        </Box>
        <Box style={{ height: '132.2px', objectFit: 'cover' }}>
          <img src={image} width={'100%'} style={{ objectFit: 'cover', height: '100%' }} />
        </Box>
        <Box paddingLeft="20px" paddingRight="20px" marginTop="10px">
          <Typography
            variant="body2"
            style={{ fontSize: '14px', color: 'black', fontWeight: 'bold' }}
          >
            {text}
          </Typography>
        </Box>
      </Box>
    </Link>
  );
});
